var PartnerType;
(function (PartnerType) {
    PartnerType["InboundApi"] = "api";
    PartnerType["Redox"] = "redox";
})(PartnerType || (PartnerType = {}));
export default PartnerType;
